import React from "react";
import RemixModalLoader from "./RemixModalLoader";
import RemixModalComplete from "./RemixModalComplete";

const RemixModalOverlay = ({
  remixLoading,
  defaultStatusMessage = "Remixing Funnel...",
}) => {
  if (!remixLoading?.loading) return null;

  if (remixLoading.complete === true) {
    return <RemixModalComplete redirectUrl={remixLoading.redirectUrl} />;
  }

  return (
    <RemixModalLoader
      statusMessage={
        remixLoading.statusMessage ||
        (remixLoading.isAiRemixing
          ? "AI remixing content..."
          : defaultStatusMessage)
      }
      progress={remixLoading.progress}
      showAiGeneratingStep={remixLoading.isAiRemixing}
    />
  );
};

export default RemixModalOverlay;
